import { DashboardChart } from '../../../common/DashboardLocalStorage';
import { constants } from '../../../common/Localization';
import { ChartFunctions, ChartTypes } from './constants';

const memoryCapacityCategory = {
    prop: 'server.performance.totalRAMInKB',
    partition: {
        labels: [ '<= 1 GiB', `1 GiB < ${constants.RAM} <= 2 GiB`, `2 GiB < ${constants.RAM} <= 8 GiB`, `8 GiB < ${constants.RAM} <= 16 GiB`, '> 16 GiB' ],
        upperBounds: [ 1024 * 1024 * 1, 1024 * 1024 * 2, 1024 * 1024 * 8, 1024 * 1024 * 16 ],
    },
};

const storageCapacityCategory = {
    prop: 'server.performance.totalDiskSizeInKB',
    partition: {
        labels: [ '<= 10 GiB', `10 GiB < ${constants.SERVER_STORAGE} <= 100 GiB`, '> 100 GiB' ],
        upperBounds: [ 1024 * 1024 * 10, 1024 * 1024 * 100 ],
    }
};

const computeUtilizationCategory = {
    prop: 'server.performance.avgCpuUsagePct',
    partition: {
        labels: [ '<= 5%', `5% < ${constants.AVG_CPU_UTIL} <= 60%`, '> 60%' ],
        upperBounds: [ 0.05, 0.6 ],
    },
};

const serverUsageCategory = {
    prop: 'server.usagePct',
    partition: {
        labels: [
            '<= 10%',
            `10% < ${constants.UPTIME} <= 20%`, `20% < ${constants.UPTIME} <= 30%`,
            `30% < ${constants.UPTIME} <= 40%`, `40% < ${constants.UPTIME} <= 50%`,
            `50% < ${constants.UPTIME} <= 60%`, `60% < ${constants.UPTIME} <= 70%`,
            `70% < ${constants.UPTIME} <= 80%`, `80% < ${constants.UPTIME} <= 90%`,
            '> 90%' ],
        upperBounds: [ 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9 ],
    },
};

export const defaultCharts: DashboardChart[] = [
    {
        id: 'defaultOpsys',
        type: ChartTypes.BAR,
        title: constants.OPERATING_SYSTEM_COUNT,
        description: constants.OPERATING_SYSTEM_COUNT_DESC,
        category: 'server.osName',
        value: { prop: 'server.osName', fn: ChartFunctions.COUNT },
        withLabels: true,
    },
    {
        id: 'defaultCompute',
        type: ChartTypes.BAR,
        title: constants.COMPUTE_CAPACITY_COUNT,
        description: constants.COMPUTE_CAPACITY_COUNT_DESC,
        category: 'server.performance.numCpus',
        value: { prop: 'server.performance.numCpus', fn: ChartFunctions.COUNT },
        withLabels: true,
    },
    {
        id: 'defaultMemory',
        type: ChartTypes.HORIZONTAL_BAR,
        title: constants.MEMORY_CAPACITY_COUNT,
        description: constants.MEMORY_CAPACITY_COUNT_DESC,
        category: memoryCapacityCategory,
        value: { prop: 'server.performance.totalRAMInKB', fn: ChartFunctions.COUNT },
        withLabels: true,
    },
    {
        id: 'defaultStorage',
        type: ChartTypes.HORIZONTAL_BAR,
        title: constants.STORAGE_CAPACITY_COUNT,
        description: constants.STORAGE_CAPACITY_COUNT_DESC,
        category: storageCapacityCategory,
        value: { prop: 'server.performance.totalDiskSizeInKB', fn: ChartFunctions.COUNT },
        withLabels: true,
    },
    {
        id: 'defaultUtilization',
        type: ChartTypes.HORIZONTAL_BAR, 
        title: constants.COMPUTE_UTILIZATION_COUNT, 
        description: constants.COMPUTE_UTILIZATION_COUNT_DESC, 
        category: computeUtilizationCategory, 
        value: { prop: 'server.performance.avgCpuUsagePct', fn: ChartFunctions.COUNT },
        withLabels: true,
    },
    { 
        id: 'defaultUptime',
        type: ChartTypes.BAR, 
        title: constants.SERVER_UPTIME_COUNT, 
        description: constants.SERVER_UPTIME_COUNT_DESC, 
        category: serverUsageCategory, 
        value: { prop: 'server.usagePct', fn: ChartFunctions.COUNT },
        withLabels: true,
    },
    { 
        id: 'defaultServerType',
        type: ChartTypes.DOUGHNUT, 
        title: constants.SERVER_TYPE_COUNT, 
        description: constants.SERVER_TYPE_COUNT_DESC, 
        sourceName: 'servers', 
        category: 'server.type', 
        value: { prop: 'server.configurationId', fn: ChartFunctions.COUNT },
        withLabels: true,
    },
    { 
        id: 'defaultInstanceType',
        type: ChartTypes.BAR, 
        title: constants.INSTANCE_TYPE_MAPPING,
        description: constants.INSTANCE_TYPE_MAPPING_DESC, 
        sourceName:'instanceTypes', 
        category: 'instanceType', 
        value: { prop: 'numInstances', fn: ChartFunctions.SUM },
        withLabels: true,
    },
    { 
        id: 'defaultInstanceCost',
        type: ChartTypes.DOUGHNUT, 
        title: constants.INSTANCE_COST, 
        description: constants.INSTANCE_COST, 
        sourceName:'instanceTypes', 
        category: 'instanceType', 
        value: { prop: 'totalCost', fn: ChartFunctions.SUM },
        withLabels: true,
    },
];
